import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { UnitResource } from "@exonn/js-sdk";

export const module: Module<UnitResource> = {
  id: ResourceEnum.Unit,
  bigIcon: <i className="icon-20-units_adm" />,
  smallIcon: <i className="icon-15-units_adm" />,
  name: (t: TFunction) => t("moduleName.units"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
